

export function replace(template: string, parameters: { [name: string]: string }) {
  for(let name in parameters) {
    template = template.replace(`{{${name}}}`, parameters[name]);
  }
  return template;
}

export function createRessourceFacade(data: { [key: string]: string }) {
  return {
    ['#RecoverPasswordSubject']: data['#RecoverPasswordSubject'] || '##RecoverPasswordSubject#',
    ['#RecoverPasswordBody']: (parameters: { name: string; link: string }) => replace(data['#RecoverPasswordBody'] || '##RecoverPasswordBody#', parameters),
    ['#EAN']: data['#EAN'] || '##EAN#',
    ['#Log in']: data['#Log in'] || '##Log in#',
    ['#Logged in']: data['#Logged in'] || '##Logged in#',
    ['#Logged in as {{name}}']: (parameters: { name: string }) => replace(data['#Logged in as {{name}}'] || '##Logged in as {{name}}#', parameters),
    ['#Log in failed']: data['#Log in failed'] || '##Log in failed#',
    ['#Log out']: data['#Log out'] || '##Log out#',
    ['#Username']: data['#Username'] || '##Username#',
    ['#Password']: data['#Password'] || '##Password#',
    ['#RecoverPasswordLink']: data['#RecoverPasswordLink'] || '##RecoverPasswordLink#',
    ['#Password changed']: data['#Password changed'] || '##Password changed#',
    ['#Password has been changed']: data['#Password has been changed'] || '##Password has been changed#',
    ['#Password change failed']: data['#Password change failed'] || '##Password change failed#',
    ['#Recover password']: data['#Recover password'] || '##Recover password#',
    ['#An email with a link to recover your password has been sent.']: data['#An email with a link to recover your password has been sent.'] || '##An email with a link to recover your password has been sent.#',
    ['#Recover password failed']: data['#Recover password failed'] || '##Recover password failed#',
    ['#Password reset']: data['#Password reset'] || '##Password reset#',
    ['#Password has been set']: data['#Password has been set'] || '##Password has been set#',
    ['#Password reset failed']: data['#Password reset failed'] || '##Password reset failed#',
    ['#Part']: data['#Part'] || '##Part#',
    ['#Material']: data['#Material'] || '##Material#',
    ['#MaterialFamily']: data['#MaterialFamily'] || '##MaterialFamily#',
    ['#Flow']: data['#Flow'] || '##Flow#',
    ['#Name']: data['#Name'] || '##Name#',
    ['#Save']: data['#Save'] || '##Save#',
    ['#Delete']: data['#Delete'] || '##Delete#',
    ['#Remove']: data['#Remove'] || '##Remove#',
    ['#Duplicate']: data['#Duplicate'] || '##Duplicate#',
    ['#Cancel']: data['#Cancel'] || '##Cancel#',
    ['#The customer has been saved']: data['#The customer has been saved'] || '##The customer has been saved#',
    ['#Do you really want to delete this customer?']: data['#Do you really want to delete this customer?'] || '##Do you really want to delete this customer?#',
    ['#Customer deleted']: data['#Customer deleted'] || '##Customer deleted#',
    ['#Customer has been deleted.']: data['#Customer has been deleted.'] || '##Customer has been deleted.#',
    ['#Material saved']: data['#Material saved'] || '##Material saved#',
    ['#Material has been saved.']: data['#Material has been saved.'] || '##Material has been saved.#',
    ['#Do you really want to delete this material?']: data['#Do you really want to delete this material?'] || '##Do you really want to delete this material?#',
    ['#Material deleted']: data['#Material deleted'] || '##Material deleted#',
    ['#Material has been deleted.']: data['#Material has been deleted.'] || '##Material has been deleted.#',
    ['#Name must be unique']: data['#Name must be unique'] || '##Name must be unique#',
    ['#Material must be unique']: data['#Material must be unique'] || '##Material must be unique#',
    ['#Flow must be unique']: data['#Flow must be unique'] || '##Flow must be unique#',
    ['#The material has been duplicated']: data['#The material has been duplicated'] || '##The material has been duplicated#',
    ['#File too big']: data['#File too big'] || '##File too big#',
    ['#The file has to be smaller or equal to 3.5 MB.']: data['#The file has to be smaller or equal to 3.5 MB.'] || '##The file has to be smaller or equal to 3.5 MB.#',
    ['#NoFlowAllocated']: data['#NoFlowAllocated'] || '##NoFlowAllocated#',
    ['#PlasticRigidMixed']: data['#PlasticRigidMixed'] || '##PlasticRigidMixed#',
    ['#PlasticFlexMixed']: data['#PlasticFlexMixed'] || '##PlasticFlexMixed#',
    ['#PE']: data['#PE'] || '##PE#',
    ['#PP']: data['#PP'] || '##PP#',
    ['#PS']: data['#PS'] || '##PS#',
    ['#PET']: data['#PET'] || '##PET#',
    ['#PlasticFilm']: data['#PlasticFilm'] || '##PlasticFilm#',
    ['#PaperAndBoard']: data['#PaperAndBoard'] || '##PaperAndBoard#',
    ['#FerrousMetals']: data['#FerrousMetals'] || '##FerrousMetals#',
    ['#NonFerrous']: data['#NonFerrous'] || '##NonFerrous#',
    ['#Glass']: data['#Glass'] || '##Glass#',
    ['#BeverageCartons']: data['#BeverageCartons'] || '##BeverageCartons#',
    ['#PETMixed']: data['#PETMixed'] || '##PETMixed#',
    ['#MixedPlastics']: data['#MixedPlastics'] || '##MixedPlastics#',
    ['#The project has been added']: data['#The project has been added'] || '##The project has been added#',
    ['#The project has errors']: data['#The project has errors'] || '##The project has errors#',
    ['#The project has been saved']: data['#The project has been saved'] || '##The project has been saved#',
    ['#Do you really want to delete the project?']: data['#Do you really want to delete the project?'] || '##Do you really want to delete the project?#',
    ['#The project has been deleted']: data['#The project has been deleted'] || '##The project has been deleted#',
    ['#Whole packaging']: data['#Whole packaging'] || '##Whole packaging#',
    ['#Scenario']: data['#Scenario'] || '##Scenario#',
    ['#The packaging has been saved']: data['#The packaging has been saved'] || '##The packaging has been saved#',
    ['#The packaging has errors']: data['#The packaging has errors'] || '##The packaging has errors#',
    ['#The packaging has been duplicated']: data['#The packaging has been duplicated'] || '##The packaging has been duplicated#',
    ['#Need save to continue']: data['#Need save to continue'] || '##Need save to continue#',
    ['#Do you really want to delete the packaging?']: data['#Do you really want to delete the packaging?'] || '##Do you really want to delete the packaging?#',
    ['#The packaging has been deleted']: data['#The packaging has been deleted'] || '##The packaging has been deleted#',
    ['#Cannot delete. Referenced as template by {{ids}}']: (parameters: { ids: string }) => replace(data['#Cannot delete. Referenced as template by {{ids}}'] || '##Cannot delete. Referenced as template by {{ids}}#', parameters),
    ['#Retain']: data['#Retain'] || '##Retain#',
    ['#The rating history will be retained']: data['#The rating history will be retained'] || '##The rating history will be retained#',
    ['#The rating history will not be retained']: data['#The rating history will not be retained'] || '##The rating history will not be retained#',
    ['#Remark']: data['#Remark'] || '##Remark#',
    ['#Remark saved']: data['#Remark saved'] || '##Remark saved#',
    ['#Do you really want to delete the rating history?']: data['#Do you really want to delete the rating history?'] || '##Do you really want to delete the rating history?#',
    ['#Rating history deleted']: data['#Rating history deleted'] || '##Rating history deleted#',
    ['#Unexpected error']: data['#Unexpected error'] || '##Unexpected error#',
    ['#Error code: {{code}}']: (parameters: { code: string }) => replace(data['#Error code: {{code}}'] || '##Error code: {{code}}#', parameters),
    ['#Error message: {{message}}']: (parameters: { message: string }) => replace(data['#Error message: {{message}}'] || '##Error message: {{message}}#', parameters),
    ['#Error: {{error}}']: (parameters: { error: string }) => replace(data['#Error: {{error}}'] || '##Error: {{error}}#', parameters),
    ['#Priority']: data['#Priority'] || '##Priority#',
    ['#ID']: data['#ID'] || '##ID#',
    ['#Material family']: data['#Material family'] || '##Material family#',
    ['#Search material']: data['#Search material'] || '##Search material#',
    ['#ResetPassword']: data['#ResetPassword'] || '##ResetPassword#',
    ['#NewPasswordConfirmation']: data['#NewPasswordConfirmation'] || '##NewPasswordConfirmation#',
    ['#NewPassword']: data['#NewPassword'] || '##NewPassword#',
    ['#ResetPasswordDescription']: data['#ResetPasswordDescription'] || '##ResetPasswordDescription#',
    ['#ResetPasswordTitle']: data['#ResetPasswordTitle'] || '##ResetPasswordTitle#',
    ['#SendRecoverPasswordEmail']: data['#SendRecoverPasswordEmail'] || '##SendRecoverPasswordEmail#',
    ['#RecoverPasswordDescription']: data['#RecoverPasswordDescription'] || '##RecoverPasswordDescription#',
    ['#RecoverPasswordTitle']: data['#RecoverPasswordTitle'] || '##RecoverPasswordTitle#',
    ['#PasswordChangeTitle']: data['#PasswordChangeTitle'] || '##PasswordChangeTitle#',
    ['#PasswordChangeDescription']: data['#PasswordChangeDescription'] || '##PasswordChangeDescription#',
    ['#Change password']: data['#Change password'] || '##Change password#',
    ['#Account']: data['#Account'] || '##Account#',
    ['#Show packagings']: data['#Show packagings'] || '##Show packagings#',
    ['#Add packaging']: data['#Add packaging'] || '##Add packaging#',
    ['#Packagings']: data['#Packagings'] || '##Packagings#',
    ['#Users']: data['#Users'] || '##Users#',
    ['#Image']: data['#Image'] || '##Image#',
    ['#Customer code']: data['#Customer code'] || '##Customer code#',
    ['#MediumNirValue']: data['#MediumNirValue'] || '##MediumNirValue#',
    ['#MediumNirBoundary']: data['#MediumNirBoundary'] || '##MediumNirBoundary#',
    ['#LowNirValue']: data['#LowNirValue'] || '##LowNirValue#',
    ['#LowNirBoundary']: data['#LowNirBoundary'] || '##LowNirBoundary#',
    ['#NIR']: data['#NIR'] || '##NIR#',
    ['#Mixed plastics long dim']: data['#Mixed plastics long dim'] || '##Mixed plastics long dim#',
    ['#Mixed plastics short dim']: data['#Mixed plastics short dim'] || '##Mixed plastics short dim#',
    ['#Plastic film long dim']: data['#Plastic film long dim'] || '##Plastic film long dim#',
    ['#Plastic film short dim']: data['#Plastic film short dim'] || '##Plastic film short dim#',
    ['#Very often separated']: data['#Very often separated'] || '##Very often separated#',
    ['#Often separated']: data['#Often separated'] || '##Often separated#',
    ['#Occasionally separated']: data['#Occasionally separated'] || '##Occasionally separated#',
    ['#Rarely separated']: data['#Rarely separated'] || '##Rarely separated#',
    ['#Never separated']: data['#Never separated'] || '##Never separated#',
    ['#Scenario calculation']: data['#Scenario calculation'] || '##Scenario calculation#',
    ['#Composites recycable']: data['#Composites recycable'] || '##Composites recycable#',
    ['#General']: data['#General'] || '##General#',
    ['#Tagline']: data['#Tagline'] || '##Tagline#',
    ['#Plastic films']: data['#Plastic films'] || '##Plastic films#',
    ['#Select']: data['#Select'] || '##Select#',
    ['#Populate remarks']: data['#Populate remarks'] || '##Populate remarks#',
    ['#Populate observations']: data['#Populate observations'] || '##Populate observations#',
    ['#Observations']: data['#Observations'] || '##Observations#',
    ['#Populate assumptions']: data['#Populate assumptions'] || '##Populate assumptions#',
    ['#Assumptions']: data['#Assumptions'] || '##Assumptions#',
    ['#Reference number']: data['#Reference number'] || '##Reference number#',
    ['#Product type']: data['#Product type'] || '##Product type#',
    ['#Customer']: data['#Customer'] || '##Customer#',
    ['#Category']: data['#Category'] || '##Category#',
    ['#Code']: data['#Code'] || '##Code#',
    ['#Owner']: data['#Owner'] || '##Owner#',
    ['#AddProjectDescription']: data['#AddProjectDescription'] || '##AddProjectDescription#',
    ['#AddProjectTitle']: data['#AddProjectTitle'] || '##AddProjectTitle#',
    ['#Changed at']: data['#Changed at'] || '##Changed at#',
    ['#Search']: data['#Search'] || '##Search#',
    ['#Add project']: data['#Add project'] || '##Add project#',
    ['#Search for projects']: data['#Search for projects'] || '##Search for projects#',
    ['#Projects']: data['#Projects'] || '##Projects#',
    ['#ClassificationsDescription']: data['#ClassificationsDescription'] || '##ClassificationsDescription#',
    ['#ClassificationsTitle']: data['#ClassificationsTitle'] || '##ClassificationsTitle#',
    ['#AddCustomerTitle']: data['#AddCustomerTitle'] || '##AddCustomerTitle#',
    ['#Product name']: data['#Product name'] || '##Product name#',
    ['#Packaging name']: data['#Packaging name'] || '##Packaging name#',
    ['#Additives']: data['#Additives'] || '##Additives#',
    ['#Colors']: data['#Colors'] || '##Colors#',
    ['#Add']: data['#Add'] || '##Add#',
    ['#Value']: data['#Value'] || '##Value#',
    ['#Type']: data['#Type'] || '##Type#',
    ['#HasError']: data['#HasError'] || '##HasError#',
    ['#HasDifferentRecycabilityClassification']: data['#HasDifferentRecycabilityClassification'] || '##HasDifferentRecycabilityClassification#',
    ['#HasDifferentRecycability']: data['#HasDifferentRecycability'] || '##HasDifferentRecycability#',
    ['#Comparison']: data['#Comparison'] || '##Comparison#',
    ['#IsCompleted']: data['#IsCompleted'] || '##IsCompleted#',
    ['#ApplicationVersion']: data['#ApplicationVersion'] || '##ApplicationVersion#',
    ['#Comment']: data['#Comment'] || '##Comment#',
    ['#Stop']: data['#Stop'] || '##Stop#',
    ['#Start']: data['#Start'] || '##Start#',
    ['#Fractions']: data['#Fractions'] || '##Fractions#',
    ['#Accepted flows']: data['#Accepted flows'] || '##Accepted flows#',
    ['#Contaminants']: data['#Contaminants'] || '##Contaminants#',
    ['#Add a new material']: data['#Add a new material'] || '##Add a new material#',
    ['#Add material']: data['#Add material'] || '##Add material#',
    ['#Properties']: data['#Properties'] || '##Properties#',
    ['#Dependencies']: data['#Dependencies'] || '##Dependencies#',
    ['#Search for materials']: data['#Search for materials'] || '##Search for materials#',
    ['#LoginDescription']: data['#LoginDescription'] || '##LoginDescription#',
    ['#LoginTitle']: data['#LoginTitle'] || '##LoginTitle#',
    ['#Created at']: data['#Created at'] || '##Created at#',
    ['#Add customer']: data['#Add customer'] || '##Add customer#',
    ['#Search for customers']: data['#Search for customers'] || '##Search for customers#',
    ['#Is hidden']: data['#Is hidden'] || '##Is hidden#',
    ['#Decomp temp']: data['#Decomp temp'] || '##Decomp temp#',
    ['#Melt temp high']: data['#Melt temp high'] || '##Melt temp high#',
    ['#Melt temp low']: data['#Melt temp low'] || '##Melt temp low#',
    ['#Material category']: data['#Material category'] || '##Material category#',
    ['#Secondary flow']: data['#Secondary flow'] || '##Secondary flow#',
    ['#Primary flow']: data['#Primary flow'] || '##Primary flow#',
    ['#CreatedAt']: data['#CreatedAt'] || '##CreatedAt#',
    ['#Materials']: data['#Materials'] || '##Materials#',
    ['#Customers']: data['#Customers'] || '##Customers#',
    ['#Customer article version']: data['#Customer article version'] || '##Customer article version#',
    ['#Customer article number']: data['#Customer article number'] || '##Customer article number#',
    ['#Content type']: data['#Content type'] || '##Content type#',
    ['#Content mass']: data['#Content mass'] || '##Content mass#',
    ['#Content volume']: data['#Content volume'] || '##Content volume#',
    ['#GTIN']: data['#GTIN'] || '##GTIN#',
    ['#Status']: data['#Status'] || '##Status#',
    ['#Product']: data['#Product'] || '##Product#',
    ['#Attachments']: data['#Attachments'] || '##Attachments#',
    ['#Additional images']: data['#Additional images'] || '##Additional images#',
    ['#Additional information']: data['#Additional information'] || '##Additional information#',
    ['#Packaging recycability']: data['#Packaging recycability'] || '##Packaging recycability#',
    ['#Recycability']: data['#Recycability'] || '##Recycability#',
    ['#Refining loss']: data['#Refining loss'] || '##Refining loss#',
    ['#Sorting loss']: data['#Sorting loss'] || '##Sorting loss#',
    ['#Overall packaging']: data['#Overall packaging'] || '##Overall packaging#',
    ['#Download review']: data['#Download review'] || '##Download review#',
    ['#Result rating']: data['#Result rating'] || '##Result rating#',
    ['#Result score']: data['#Result score'] || '##Result score#',
    ['#PackagingResult']: data['#PackagingResult'] || '##PackagingResult#',
    ['#PackagingInformation']: data['#PackagingInformation'] || '##PackagingInformation#',
    ['#PackagingParts']: data['#PackagingParts'] || '##PackagingParts#',
    ['#NoTemplateHelpHtml']: data['#NoTemplateHelpHtml'] || '##NoTemplateHelpHtml#',
    ['#Search for template']: data['#Search for template'] || '##Search for template#',
    ['#AddPackagingStep3']: data['#AddPackagingStep3'] || '##AddPackagingStep3#',
    ['#AddPackagingStep2']: data['#AddPackagingStep2'] || '##AddPackagingStep2#',
    ['#AddPackagingStep1']: data['#AddPackagingStep1'] || '##AddPackagingStep1#',
    ['#Continue']: data['#Continue'] || '##Continue#',
    ['#AddPackagingDescription']: data['#AddPackagingDescription'] || '##AddPackagingDescription#',
    ['#AddPackagingTitle']: data['#AddPackagingTitle'] || '##AddPackagingTitle#',
    ['#Search text']: data['#Search text'] || '##Search text#',
    ['#All users']: data['#All users'] || '##All users#',
    ['#Hide classifications']: data['#Hide classifications'] || '##Hide classifications#',
    ['#Show classifications']: data['#Show classifications'] || '##Show classifications#',
    ['#Search for packagings']: data['#Search for packagings'] || '##Search for packagings#',
    ['#Created on']: data['#Created on'] || '##Created on#',
    ['#Remarks']: data['#Remarks'] || '##Remarks#',
    ['#AddCustomerDescription']: data['#AddCustomerDescription'] || '##AddCustomerDescription#',
    ['#Related part']: data['#Related part'] || '##Related part#',
    ['#Separation probability']: data['#Separation probability'] || '##Separation probability#',
    ['#Combinations']: data['#Combinations'] || '##Combinations#',
    ['#Classifications']: data['#Classifications'] || '##Classifications#',
    ['#Rating']: data['#Rating'] || '##Rating#',
    ['#Occurence']: data['#Occurence'] || '##Occurence#',
    ['#Rating history']: data['#Rating history'] || '##Rating history#',
    ['#Is template']: data['#Is template'] || '##Is template#',
    ['#Observation']: data['#Observation'] || '##Observation#',
    ['#Assumption']: data['#Assumption'] || '##Assumption#',
    ['#Default calculation']: data['#Default calculation'] || '##Default calculation#',
    ['#Quality of recyclate']: data['#Quality of recyclate'] || '##Quality of recyclate#',
    ['#Regeneration capability']: data['#Regeneration capability'] || '##Regeneration capability#',
    ['#Refining score']: data['#Refining score'] || '##Refining score#',
    ['#Sorting score']: data['#Sorting score'] || '##Sorting score#',
    ['#Target material']: data['#Target material'] || '##Target material#',
    ['#Download']: data['#Download'] || '##Download#',
    ['#RelationLimitedHelpHtml']: data['#RelationLimitedHelpHtml'] || '##RelationLimitedHelpHtml#',
    ['#Very often']: data['#Very often'] || '##Very often#',
    ['#Often']: data['#Often'] || '##Often#',
    ['#Occasionally']: data['#Occasionally'] || '##Occasionally#',
    ['#Rarely']: data['#Rarely'] || '##Rarely#',
    ['#Never']: data['#Never'] || '##Never#',
    ['#Weight']: data['#Weight'] || '##Weight#',
    ['#Y']: data['#Y'] || '##Y#',
    ['#Z']: data['#Z'] || '##Z#',
    ['#X']: data['#X'] || '##X#',
    ['#Square']: data['#Square'] || '##Square#',
    ['#Round']: data['#Round'] || '##Round#',
    ['#Shape']: data['#Shape'] || '##Shape#',
    ['#Color']: data['#Color'] || '##Color#',
    ['#Component']: data['#Component'] || '##Component#',
    ['#Adhesive']: data['#Adhesive'] || '##Adhesive#',
    ['#Composite']: data['#Composite'] || '##Composite#',
    ['#Sum of fractions must be 100%']: data['#Sum of fractions must be 100%'] || '##Sum of fractions must be 100%#',
    ['#PackagingDebug']: data['#PackagingDebug'] || '##PackagingDebug#',
    ['#PackagingRelations']: data['#PackagingRelations'] || '##PackagingRelations#',
    ['#Components']: data['#Components'] || '##Components#',
    ['#NoTemplateDescription']: data['#NoTemplateDescription'] || '##NoTemplateDescription#',
    ['#All projects']: data['#All projects'] || '##All projects#',
    ['#NextErrorMessage']: data['#NextErrorMessage'] || '##NextErrorMessage#',
    ['#PrevErrorMessage']: data['#PrevErrorMessage'] || '##PrevErrorMessage#',
    ['#NextRecycabilityClassification']: data['#NextRecycabilityClassification'] || '##NextRecycabilityClassification#',
    ['#PrevRecycabilityClassification']: data['#PrevRecycabilityClassification'] || '##PrevRecycabilityClassification#',
    ['#DiffRecycability']: data['#DiffRecycability'] || '##DiffRecycability#',
    ['#Project']: data['#Project'] || '##Project#',
    ['#All customers']: data['#All customers'] || '##All customers#',
    ['#ErrorMessage']: data['#ErrorMessage'] || '##ErrorMessage#',
    ['#RecycabilityClassification']: data['#RecycabilityClassification'] || '##RecycabilityClassification#',
    ['#Administration']: data['#Administration'] || '##Administration#',
    ['#WelcomeCertifyHtml']: data['#WelcomeCertifyHtml'] || '##WelcomeCertifyHtml#',
    ['#WelcomeLimitedHtml']: data['#WelcomeLimitedHtml'] || '##WelcomeLimitedHtml#',
    ['#WelcomeHtml']: data['#WelcomeHtml'] || '##WelcomeHtml#',
    ['#Please select an image']: data['#Please select an image'] || '##Please select an image#',
    ['#Weight fraction']: data['#Weight fraction'] || '##Weight fraction#',
    ['#Document']: data['#Document'] || '##Document#',
    ['#NoTemplateTitle']: data['#NoTemplateTitle'] || '##NoTemplateTitle#',
    ['#Sum of fractions should be 100%']: data['#Sum of fractions should be 100%'] || '##Sum of fractions should be 100%#',
    ['#PrevRecycability']: data['#PrevRecycability'] || '##PrevRecycability#',
    ['#NextRecycability']: data['#NextRecycability'] || '##NextRecycability#',
    ['#Show projects']: data['#Show projects'] || '##Show projects#',
    ['#Confirm Action']: data['#Confirm Action'] || '##Confirm Action#',
    ['#{0} items selected']: data['#{0} items selected'] || '##{0} items selected#',
    ['#Add group']: data['#Add group'] || '##Add group#',
    ['#Move up']: data['#Move up'] || '##Move up#',
    ['#Move down']: data['#Move down'] || '##Move down#',
    ['#ClassificationRoot']: data['#ClassificationRoot'] || '##ClassificationRoot#',
    ['#UniqueProjectCodeError']: data['#UniqueProjectCodeError'] || '##UniqueProjectCodeError#',
    ['#Please select a file']: data['#Please select a file'] || '##Please select a file#',
    ['#tooltip_customer_name']: data['#tooltip_customer_name'] || '##tooltip_customer_name#',
    ['#tooltip_customer_code']: data['#tooltip_customer_code'] || '##tooltip_customer_code#',
    ['#tooltip_customer_image']: data['#tooltip_customer_image'] || '##tooltip_customer_image#',
    ['#tooltip_customer_users']: data['#tooltip_customer_users'] || '##tooltip_customer_users#',
    ['#tooltip_login_name']: data['#tooltip_login_name'] || '##tooltip_login_name#',
    ['#tooltip_login_password']: data['#tooltip_login_password'] || '##tooltip_login_password#',
    ['#tooltip_password_password']: data['#tooltip_password_password'] || '##tooltip_password_password#',
    ['#tooltip_password_new-password']: data['#tooltip_password_new-password'] || '##tooltip_password_new-password#',
    ['#tooltip_password_password-confirmation']: data['#tooltip_password_password-confirmation'] || '##tooltip_password_password-confirmation#',
    ['#tooltip_recover_username']: data['#tooltip_recover_username'] || '##tooltip_recover_username#',
    ['#tooltip_reset_new-password']: data['#tooltip_reset_new-password'] || '##tooltip_reset_new-password#',
    ['#tooltip_reset_new-password-confirmation']: data['#tooltip_reset_new-password-confirmation'] || '##tooltip_reset_new-password-confirmation#',
    ['#tooltip_pproject_populate-observations']: data['#tooltip_pproject_populate-observations'] || '##tooltip_pproject_populate-observations#',
    ['#tooltip_pproject_remarks']: data['#tooltip_pproject_remarks'] || '##tooltip_pproject_remarks#',
    ['#tooltip_pproject_populate-remarks']: data['#tooltip_pproject_populate-remarks'] || '##tooltip_pproject_populate-remarks#',
    ['#tooltip_pproject_observations']: data['#tooltip_pproject_observations'] || '##tooltip_pproject_observations#',
    ['#tooltip_pproject_populate-assumptions']: data['#tooltip_pproject_populate-assumptions'] || '##tooltip_pproject_populate-assumptions#',
    ['#tooltip_pproject_assumptions']: data['#tooltip_pproject_assumptions'] || '##tooltip_pproject_assumptions#',
    ['#tooltip_pproject_reference-number']: data['#tooltip_pproject_reference-number'] || '##tooltip_pproject_reference-number#',
    ['#tooltip_pproject_product-type']: data['#tooltip_pproject_product-type'] || '##tooltip_pproject_product-type#',
    ['#tooltip_pproject_customer']: data['#tooltip_pproject_customer'] || '##tooltip_pproject_customer#',
    ['#tooltip_pproject_category']: data['#tooltip_pproject_category'] || '##tooltip_pproject_category#',
    ['#tooltip_pproject_code']: data['#tooltip_pproject_code'] || '##tooltip_pproject_code#',
    ['#tooltip_pproject_name']: data['#tooltip_pproject_name'] || '##tooltip_pproject_name#',
    ['#tooltip_pproject_owner']: data['#tooltip_pproject_owner'] || '##tooltip_pproject_owner#',
    ['#tooltip_classification_name']: data['#tooltip_classification_name'] || '##tooltip_classification_name#',
    ['#tooltip_customers_search']: data['#tooltip_customers_search'] || '##tooltip_customers_search#',
    ['#tooltip_additives_value']: data['#tooltip_additives_value'] || '##tooltip_additives_value#',
    ['#tooltip_additives_is-solubility-modifier']: data['#tooltip_additives_is-solubility-modifier'] || '##tooltip_additives_is-solubility-modifier#',
    ['#tooltip_additives_is-density-modifier']: data['#tooltip_additives_is-density-modifier'] || '##tooltip_additives_is-density-modifier#',
    ['#tooltip_additives_type']: data['#tooltip_additives_type'] || '##tooltip_additives_type#',
    ['#tooltip_additives_name']: data['#tooltip_additives_name'] || '##tooltip_additives_name#',
    ['#tooltip_colors_number']: data['#tooltip_colors_number'] || '##tooltip_colors_number#',
    ['#tooltip_materials_is-hidden']: data['#tooltip_materials_is-hidden'] || '##tooltip_materials_is-hidden#',
    ['#tooltip_materials_decomp-temp']: data['#tooltip_materials_decomp-temp'] || '##tooltip_materials_decomp-temp#',
    ['#tooltip_materials_melt-temp-high']: data['#tooltip_materials_melt-temp-high'] || '##tooltip_materials_melt-temp-high#',
    ['#tooltip_materials_melt-temp-low']: data['#tooltip_materials_melt-temp-low'] || '##tooltip_materials_melt-temp-low#',
    ['#tooltip_materials_solubility']: data['#tooltip_materials_solubility'] || '##tooltip_materials_solubility#',
    ['#tooltip_materials_density-high']: data['#tooltip_materials_density-high'] || '##tooltip_materials_density-high#',
    ['#tooltip_materials_density-low']: data['#tooltip_materials_density-low'] || '##tooltip_materials_density-low#',
    ['#tooltip_materials_priority']: data['#tooltip_materials_priority'] || '##tooltip_materials_priority#',
    ['#tooltip_materials_material-category']: data['#tooltip_materials_material-category'] || '##tooltip_materials_material-category#',
    ['#tooltip_materials_secondary-flow']: data['#tooltip_materials_secondary-flow'] || '##tooltip_materials_secondary-flow#',
    ['#tooltip_materials_primary-flow']: data['#tooltip_materials_primary-flow'] || '##tooltip_materials_primary-flow#',
    ['#tooltip_materials_material-family']: data['#tooltip_materials_material-family'] || '##tooltip_materials_material-family#',
    ['#tooltip_materials_name']: data['#tooltip_materials_name'] || '##tooltip_materials_name#',
    ['#tooltip_materials_search']: data['#tooltip_materials_search'] || '##tooltip_materials_search#',
    ['#tooltip_pproject_search']: data['#tooltip_pproject_search'] || '##tooltip_pproject_search#',
    ['#tooltip_colors_name']: data['#tooltip_colors_name'] || '##tooltip_colors_name#',
    ['#tooltip_report_detail_customer-article-version']: data['#tooltip_report_detail_customer-article-version'] || '##tooltip_report_detail_customer-article-version#',
    ['#tooltip_report_detail_customer-article-number']: data['#tooltip_report_detail_customer-article-number'] || '##tooltip_report_detail_customer-article-number#',
    ['#tooltip_report_detail_content-type']: data['#tooltip_report_detail_content-type'] || '##tooltip_report_detail_content-type#',
    ['#tooltip_report_detail_content-mass']: data['#tooltip_report_detail_content-mass'] || '##tooltip_report_detail_content-mass#',
    ['#tooltip_report_detail_content-volume']: data['#tooltip_report_detail_content-volume'] || '##tooltip_report_detail_content-volume#',
    ['#tooltip_report_detail_reference-number']: data['#tooltip_report_detail_reference-number'] || '##tooltip_report_detail_reference-number#',
    ['#tooltip_report_detail_product-type']: data['#tooltip_report_detail_product-type'] || '##tooltip_report_detail_product-type#',
    ['#tooltip_report_detail_gtin']: data['#tooltip_report_detail_gtin'] || '##tooltip_report_detail_gtin#',
    ['#tooltip_report_detail_status']: data['#tooltip_report_detail_status'] || '##tooltip_report_detail_status#',
    ['#tooltip_report_detail_product']: data['#tooltip_report_detail_product'] || '##tooltip_report_detail_product#',
    ['#tooltip_report_detail_name']: data['#tooltip_report_detail_name'] || '##tooltip_report_detail_name#',
    ['#tooltip_report_detail_classifications']: data['#tooltip_report_detail_classifications'] || '##tooltip_report_detail_classifications#',
    ['#tooltip_report_detail_is-template']: data['#tooltip_report_detail_is-template'] || '##tooltip_report_detail_is-template#',
    ['#tooltip_report_detail_observation']: data['#tooltip_report_detail_observation'] || '##tooltip_report_detail_observation#',
    ['#tooltip_report_detail_remarks']: data['#tooltip_report_detail_remarks'] || '##tooltip_report_detail_remarks#',
    ['#tooltip_report_detail_assumption']: data['#tooltip_report_detail_assumption'] || '##tooltip_report_detail_assumption#',
    ['#tooltip_report_detail_owner']: data['#tooltip_report_detail_owner'] || '##tooltip_report_detail_owner#',
    ['#tooltip_report_detail_project']: data['#tooltip_report_detail_project'] || '##tooltip_report_detail_project#',
    ['#tooltip_report_detail_relation_separation-probability']: data['#tooltip_report_detail_relation_separation-probability'] || '##tooltip_report_detail_relation_separation-probability#',
    ['#tooltip_report_detail_relation_part']: data['#tooltip_report_detail_relation_part'] || '##tooltip_report_detail_relation_part#',
    ['#tooltip_report_detail_part_image']: data['#tooltip_report_detail_part_image'] || '##tooltip_report_detail_part_image#',
    ['#tooltip_report_detail_part_weight']: data['#tooltip_report_detail_part_weight'] || '##tooltip_report_detail_part_weight#',
    ['#tooltip_report_detail_part_y']: data['#tooltip_report_detail_part_y'] || '##tooltip_report_detail_part_y#',
    ['#tooltip_report_detail_part_z']: data['#tooltip_report_detail_part_z'] || '##tooltip_report_detail_part_z#',
    ['#tooltip_report_detail_part_x']: data['#tooltip_report_detail_part_x'] || '##tooltip_report_detail_part_x#',
    ['#tooltip_report_detail_part_shape']: data['#tooltip_report_detail_part_shape'] || '##tooltip_report_detail_part_shape#',
    ['#tooltip_report_detail_part_additives']: data['#tooltip_report_detail_part_additives'] || '##tooltip_report_detail_part_additives#',
    ['#tooltip_report_detail_part_color']: data['#tooltip_report_detail_part_color'] || '##tooltip_report_detail_part_color#',
    ['#tooltip_report_detail_part_material']: data['#tooltip_report_detail_part_material'] || '##tooltip_report_detail_part_material#',
    ['#tooltip_report_detail_part_material-family']: data['#tooltip_report_detail_part_material-family'] || '##tooltip_report_detail_part_material-family#',
    ['#tooltip_report_detail_part_component']: data['#tooltip_report_detail_part_component'] || '##tooltip_report_detail_part_component#',
    ['#tooltip_report_detail_part_name']: data['#tooltip_report_detail_part_name'] || '##tooltip_report_detail_part_name#',
    ['#tooltip_report_detail_part_density-high']: data['#tooltip_report_detail_part_density-high'] || '##tooltip_report_detail_part_density-high#',
    ['#tooltip_report_detail_part_density-low']: data['#tooltip_report_detail_part_density-low'] || '##tooltip_report_detail_part_density-low#',
    ['#tooltip_report_detail_part_spring']: data['#tooltip_report_detail_part_spring'] || '##tooltip_report_detail_part_spring#',
    ['#tooltip_report_detail_part_adhesive']: data['#tooltip_report_detail_part_adhesive'] || '##tooltip_report_detail_part_adhesive#',
    ['#tooltip_report_detail_part_seal']: data['#tooltip_report_detail_part_seal'] || '##tooltip_report_detail_part_seal#',
    ['#tooltip_report_detail_part_composite_contains-adhesives']: data['#tooltip_report_detail_part_composite_contains-adhesives'] || '##tooltip_report_detail_part_composite_contains-adhesives#',
    ['#tooltip_report_detail_part_composite_material-fraction']: data['#tooltip_report_detail_part_composite_material-fraction'] || '##tooltip_report_detail_part_composite_material-fraction#',
    ['#tooltip_report_detail_part_composite_material']: data['#tooltip_report_detail_part_composite_material'] || '##tooltip_report_detail_part_composite_material#',
    ['#tooltip_report_info_name']: data['#tooltip_report_info_name'] || '##tooltip_report_info_name#',
    ['#tooltip_report_info_product']: data['#tooltip_report_info_product'] || '##tooltip_report_info_product#',
    ['#tooltip_report_template_search']: data['#tooltip_report_template_search'] || '##tooltip_report_template_search#',
    ['#tooltip_report_detail_search_text']: data['#tooltip_report_detail_search_text'] || '##tooltip_report_detail_search_text#',
    ['#tooltip_report_detail_search_project']: data['#tooltip_report_detail_search_project'] || '##tooltip_report_detail_search_project#',
    ['#tooltip_report_detail_search_owner']: data['#tooltip_report_detail_search_owner'] || '##tooltip_report_detail_search_owner#',
    ['#Unknown']: data['#Unknown'] || '##Unknown#',
    ['#Polyester']: data['#Polyester'] || '##Polyester#',
    ['#Polyolefin']: data['#Polyolefin'] || '##Polyolefin#',
    ['#Styrenic']: data['#Styrenic'] || '##Styrenic#',
    ['#None']: data['#None'] || '##None#',
    ['#Polyamide']: data['#Polyamide'] || '##Polyamide#',
    ['#Polypropylen']: data['#Polypropylen'] || '##Polypropylen#',
    ['#PolyesterMod']: data['#PolyesterMod'] || '##PolyesterMod#',
    ['#OtherPlastics']: data['#OtherPlastics'] || '##OtherPlastics#',
    ['#Vinyl']: data['#Vinyl'] || '##Vinyl#',
    ['#Fibers']: data['#Fibers'] || '##Fibers#',
    ['#Metals']: data['#Metals'] || '##Metals#',
    ['#Ceramic']: data['#Ceramic'] || '##Ceramic#',
    ['#No']: data['#No'] || '##No#',
    ['#Yes']: data['#Yes'] || '##Yes#',
    ['#Maybe']: data['#Maybe'] || '##Maybe#',
    ['#Partial']: data['#Partial'] || '##Partial#',
    ['#Standard']: data['#Standard'] || '##Standard#',
    ['#Light']: data['#Light'] || '##Light#',
    ['#Silver']: data['#Silver'] || '##Silver#',
    ['#Gold']: data['#Gold'] || '##Gold#',
    ['#Combination']: data['#Combination'] || '##Combination#',
    ['#Prototype']: data['#Prototype'] || '##Prototype#',
    ['#Model']: data['#Model'] || '##Model#',
    ['#Circulation']: data['#Circulation'] || '##Circulation#',
    ['#Solid']: data['#Solid'] || '##Solid#',
    ['#Pasty']: data['#Pasty'] || '##Pasty#',
    ['#Liquid']: data['#Liquid'] || '##Liquid#',
    ['#Packaging']: data['#Packaging'] || '##Packaging#',
    ['#Scenarios']: data['#Scenarios'] || '##Scenarios#',
    ['shared']: {
      ['id']: data['shared/id'] || '#shared/id#',
      ['yes']: data['shared/yes'] || '#shared/yes#',
      ['no']: data['shared/no'] || '#shared/no#',
      ['name']: data['shared/name'] || '#shared/name#',
      ['text']: data['shared/text'] || '#shared/text#',
      ['createdAt']: data['shared/createdAt'] || '#shared/createdAt#',
      ['changedAt']: data['shared/changedAt'] || '#shared/changedAt#',
      ['proposals']: data['shared/proposals'] || '#shared/proposals#',
      ['customer']: data['shared/customer'] || '#shared/customer#',
      ['project']: data['shared/project'] || '#shared/project#',
      ['packagings']: data['shared/packagings'] || '#shared/packagings#',
      ['missingInput']: data['shared/missingInput'] || '#shared/missingInput#',
      ['pageInfo']: (parameters: { pageNumber: string; totalPages: string }) => replace(data['shared/pageInfo'] || '#shared/pageInfo#', parameters),
      ['add']: {
        ['button']: {
          ['text']: data['shared/add/button/text'] || '#shared/add/button/text#',
        },
      },
      ['save']: {
        ['button']: {
          ['text']: data['shared/save/button/text'] || '#shared/save/button/text#',
        },
      },
      ['delete']: {
        ['button']: {
          ['text']: data['shared/delete/button/text'] || '#shared/delete/button/text#',
        },
      },
      ['cancel']: {
        ['button']: {
          ['text']: data['shared/cancel/button/text'] || '#shared/cancel/button/text#',
        },
      },
      ['selection']: {
        ['placeholder']: data['shared/selection/placeholder'] || '#shared/selection/placeholder#',
      },
      ['filter']: {
        ['reset']: {
          ['button']: {
            ['text']: data['shared/filter/reset/button/text'] || '#shared/filter/reset/button/text#',
          },
        },
      },
      ['lang']: {
        ['en']: data['shared/lang/en'] || '#shared/lang/en#',
        ['de']: data['shared/lang/de'] || '#shared/lang/de#',
        ['es']: data['shared/lang/es'] || '#shared/lang/es#',
        ['fr']: data['shared/lang/fr'] || '#shared/lang/fr#',
        ['sk']: data['shared/lang/sk'] || '#shared/lang/sk#',
      },
    },
    ['admin']: {
      ['proposals']: {
        ['properties']: {
          ['isPublished']: data['admin/proposals/properties/isPublished'] || '#admin/proposals/properties/isPublished#',
          ['proposed']: data['admin/proposals/properties/proposed'] || '#admin/proposals/properties/proposed#',
          ['packagingsCount']: data['admin/proposals/properties/packagingsCount'] || '#admin/proposals/properties/packagingsCount#',
          ['templatesCount']: data['admin/proposals/properties/templatesCount'] || '#admin/proposals/properties/templatesCount#',
        },
        ['save']: {
          ['success']: {
            ['title']: data['admin/proposals/save/success/title'] || '#admin/proposals/save/success/title#',
            ['message']: data['admin/proposals/save/success/message'] || '#admin/proposals/save/success/message#',
          },
        },
        ['duplicate']: {
          ['success']: {
            ['title']: data['admin/proposals/duplicate/success/title'] || '#admin/proposals/duplicate/success/title#',
            ['message']: data['admin/proposals/duplicate/success/message'] || '#admin/proposals/duplicate/success/message#',
          },
        },
        ['delete']: {
          ['confirm']: {
            ['message']: data['admin/proposals/delete/confirm/message'] || '#admin/proposals/delete/confirm/message#',
          },
          ['success']: {
            ['title']: data['admin/proposals/delete/success/title'] || '#admin/proposals/delete/success/title#',
            ['message']: data['admin/proposals/delete/success/message'] || '#admin/proposals/delete/success/message#',
          },
        },
        ['add']: {
          ['button']: {
            ['text']: data['admin/proposals/add/button/text'] || '#admin/proposals/add/button/text#',
          },
          ['header']: {
            ['title']: data['admin/proposals/add/header/title'] || '#admin/proposals/add/header/title#',
            ['description']: data['admin/proposals/add/header/description'] || '#admin/proposals/add/header/description#',
          },
        },
        ['detail']: {
          ['header']: {
            ['title']: data['admin/proposals/detail/header/title'] || '#admin/proposals/detail/header/title#',
            ['description']: data['admin/proposals/detail/header/description'] || '#admin/proposals/detail/header/description#',
          },
        },
        ['search']: {
          ['header']: {
            ['title']: data['admin/proposals/search/header/title'] || '#admin/proposals/search/header/title#',
            ['description']: data['admin/proposals/search/header/description'] || '#admin/proposals/search/header/description#',
          },
          ['filter']: {
            ['unpublished']: {
              ['text']: data['admin/proposals/search/filter/unpublished/text'] || '#admin/proposals/search/filter/unpublished/text#',
            },
          },
        },
      },
      ['translations']: {
        ['placeholders']: data['admin/translations/placeholders'] || '#admin/translations/placeholders#',
        ['save']: {
          ['success']: {
            ['title']: data['admin/translations/save/success/title'] || '#admin/translations/save/success/title#',
            ['message']: data['admin/translations/save/success/message'] || '#admin/translations/save/success/message#',
          },
        },
        ['delete']: {
          ['success']: {
            ['title']: data['admin/translations/delete/success/title'] || '#admin/translations/delete/success/title#',
            ['message']: data['admin/translations/delete/success/message'] || '#admin/translations/delete/success/message#',
          },
          ['confirm']: {
            ['message']: data['admin/translations/delete/confirm/message'] || '#admin/translations/delete/confirm/message#',
          },
        },
        ['detail']: {
          ['header']: {
            ['title']: data['admin/translations/detail/header/title'] || '#admin/translations/detail/header/title#',
          },
        },
        ['search']: {
          ['header']: {
            ['title']: data['admin/translations/search/header/title'] || '#admin/translations/search/header/title#',
            ['description']: data['admin/translations/search/header/description'] || '#admin/translations/search/header/description#',
          },
          ['filter']: {
            ['languages']: {
              ['placeholder']: data['admin/translations/search/filter/languages/placeholder'] || '#admin/translations/search/filter/languages/placeholder#',
            },
          },
        },
      },
    },
    ['dashboard']: {
      ['links']: {
        ['translations']: {
          ['title']: data['dashboard/links/translations/title'] || '#dashboard/links/translations/title#',
        },
        ['proposals']: {
          ['title']: data['dashboard/links/proposals/title'] || '#dashboard/links/proposals/title#',
        },
      },
      ['groups']: {
        ['consulting']: {
          ['title']: data['dashboard/groups/consulting/title'] || '#dashboard/groups/consulting/title#',
        },
      },
    },
    ['packaging']: {
      ['properties']: {
        ['content']: data['packaging/properties/content'] || '#packaging/properties/content#',
        ['defaultCalculation']: data['packaging/properties/defaultCalculation'] || '#packaging/properties/defaultCalculation#',
        ['composite']: {
          ['inside']: data['packaging/properties/composite/inside'] || '#packaging/properties/composite/inside#',
          ['outside']: data['packaging/properties/composite/outside'] || '#packaging/properties/composite/outside#',
        },
        ['info']: {
          ['defaultCalculation']: data['packaging/properties/info/defaultCalculation'] || '#packaging/properties/info/defaultCalculation#',
        },
        ['isRadioactive']: {
          ['label']: data['packaging/properties/isRadioactive/label'] || '#packaging/properties/isRadioactive/label#',
          ['description']: data['packaging/properties/isRadioactive/description'] || '#packaging/properties/isRadioactive/description#',
        },
        ['isInfectious']: {
          ['label']: data['packaging/properties/isInfectious/label'] || '#packaging/properties/isInfectious/label#',
          ['description']: data['packaging/properties/isInfectious/description'] || '#packaging/properties/isInfectious/description#',
        },
        ['isOtherHazardous']: {
          ['label']: data['packaging/properties/isOtherHazardous/label'] || '#packaging/properties/isOtherHazardous/label#',
          ['description']: data['packaging/properties/isOtherHazardous/description'] || '#packaging/properties/isOtherHazardous/description#',
        },
        ['isSealant']: {
          ['label']: data['packaging/properties/isSealant/label'] || '#packaging/properties/isSealant/label#',
          ['description']: data['packaging/properties/isSealant/description'] || '#packaging/properties/isSealant/description#',
        },
      },
    },
    ['part']: {
      ['containsBarrierLabel']: data['part/containsBarrierLabel'] || '#part/containsBarrierLabel#',
      ['barrierAddedSummary']: data['part/barrierAddedSummary'] || '#part/barrierAddedSummary#',
      ['barrierAddedDetail']: data['part/barrierAddedDetail'] || '#part/barrierAddedDetail#',
      ['dimensionLabelInfo']: data['part/dimensionLabelInfo'] || '#part/dimensionLabelInfo#',
      ['properties']: {
        ['densityModification']: data['part/properties/densityModification'] || '#part/properties/densityModification#',
        ['density']: data['part/properties/density'] || '#part/properties/density#',
        ['densityTo']: data['part/properties/densityTo'] || '#part/properties/densityTo#',
        ['color']: {
          ['label']: data['part/properties/color/label'] || '#part/properties/color/label#',
          ['description']: data['part/properties/color/description'] || '#part/properties/color/description#',
        },
        ['ncBasedPrinting']: {
          ['label']: data['part/properties/ncBasedPrinting/label'] || '#part/properties/ncBasedPrinting/label#',
          ['description']: data['part/properties/ncBasedPrinting/description'] || '#part/properties/ncBasedPrinting/description#',
        },
      },
    },
    ['rating']: {
      ['properties']: {
        ['calculation']: data['rating/properties/calculation'] || '#rating/properties/calculation#',
      },
    },
    ['adhesive']: {
      ['properties']: {
        ['type']: {
          ['label']: data['adhesive/properties/type/label'] || '#adhesive/properties/type/label#',
          ['description']: data['adhesive/properties/type/description'] || '#adhesive/properties/type/description#',
        },
        ['fraction']: {
          ['label']: data['adhesive/properties/fraction/label'] || '#adhesive/properties/fraction/label#',
          ['description']: data['adhesive/properties/fraction/description'] || '#adhesive/properties/fraction/description#',
        },
        ['application']: {
          ['label']: data['adhesive/properties/application/label'] || '#adhesive/properties/application/label#',
          ['description']: data['adhesive/properties/application/description'] || '#adhesive/properties/application/description#',
        },
      },
    },
    ['finishing']: {
      ['properties']: {
        ['type']: {
          ['label']: data['finishing/properties/type/label'] || '#finishing/properties/type/label#',
          ['description']: data['finishing/properties/type/description'] || '#finishing/properties/type/description#',
        },
        ['surface']: {
          ['label']: data['finishing/properties/surface/label'] || '#finishing/properties/surface/label#',
          ['description']: data['finishing/properties/surface/description'] || '#finishing/properties/surface/description#',
        },
        ['thickness']: {
          ['label']: data['finishing/properties/thickness/label'] || '#finishing/properties/thickness/label#',
          ['description']: data['finishing/properties/thickness/description'] || '#finishing/properties/thickness/description#',
        },
        ['containsMetal']: {
          ['label']: data['finishing/properties/containsMetal/label'] || '#finishing/properties/containsMetal/label#',
          ['description']: data['finishing/properties/containsMetal/description'] || '#finishing/properties/containsMetal/description#',
        },
        ['isTransparent']: {
          ['label']: data['finishing/properties/isTransparent/label'] || '#finishing/properties/isTransparent/label#',
          ['description']: data['finishing/properties/isTransparent/description'] || '#finishing/properties/isTransparent/description#',
        },
      },
    },
    ['color']: {
      ['properties']: {
        ['isTransparent']: data['color/properties/isTransparent'] || '#color/properties/isTransparent#',
      },
    },
    ['material']: {
      ['properties']: {
        ['inCompositeOnly']: {
          ['label']: data['material/properties/inCompositeOnly/label'] || '#material/properties/inCompositeOnly/label#',
          ['description']: data['material/properties/inCompositeOnly/description'] || '#material/properties/inCompositeOnly/description#',
        },
      },
    },
    ['enums']: {
      ['RecycabilityClassification']: {
        ['Unknown']: data['enums/RecycabilityClassification/Unknown'] || '#enums/RecycabilityClassification/Unknown#',
        ['C']: data['enums/RecycabilityClassification/C'] || '#enums/RecycabilityClassification/C#',
        ['B']: data['enums/RecycabilityClassification/B'] || '#enums/RecycabilityClassification/B#',
        ['A']: data['enums/RecycabilityClassification/A'] || '#enums/RecycabilityClassification/A#',
        ['Aplus']: data['enums/RecycabilityClassification/Aplus'] || '#enums/RecycabilityClassification/Aplus#',
        ['Aplusplus']: data['enums/RecycabilityClassification/Aplusplus'] || '#enums/RecycabilityClassification/Aplusplus#',
        ['Aplusplusplus']: data['enums/RecycabilityClassification/Aplusplusplus'] || '#enums/RecycabilityClassification/Aplusplusplus#',
      },
      ['ScenarioCalculation']: {
        ['Packaging']: data['enums/ScenarioCalculation/Packaging'] || '#enums/ScenarioCalculation/Packaging#',
        ['Scenarios']: data['enums/ScenarioCalculation/Scenarios'] || '#enums/ScenarioCalculation/Scenarios#',
        ['Parts']: data['enums/ScenarioCalculation/Parts'] || '#enums/ScenarioCalculation/Parts#',
      },
      ['RecycabilityCalculation']: {
        ['DE2022']: data['enums/RecycabilityCalculation/DE2022'] || '#enums/RecycabilityCalculation/DE2022#',
        ['AT2022']: data['enums/RecycabilityCalculation/AT2022'] || '#enums/RecycabilityCalculation/AT2022#',
        ['FR2022']: data['enums/RecycabilityCalculation/FR2022'] || '#enums/RecycabilityCalculation/FR2022#',
        ['DE2023']: data['enums/RecycabilityCalculation/DE2023'] || '#enums/RecycabilityCalculation/DE2023#',
        ['DE2024']: data['enums/RecycabilityCalculation/DE2024'] || '#enums/RecycabilityCalculation/DE2024#',
      },
      ['FinishingType']: {
        ['VapourDeposition']: data['enums/FinishingType/VapourDeposition'] || '#enums/FinishingType/VapourDeposition#',
        ['Lacquering']: data['enums/FinishingType/Lacquering'] || '#enums/FinishingType/Lacquering#',
        ['Embossing']: data['enums/FinishingType/Embossing'] || '#enums/FinishingType/Embossing#',
        ['PolymericThermoplasticDispersionCoating']: data['enums/FinishingType/PolymericThermoplasticDispersionCoating'] || '#enums/FinishingType/PolymericThermoplasticDispersionCoating#',
      },
      ['AdhesiveType']: {
        ['None']: data['enums/AdhesiveType/None'] || '#enums/AdhesiveType/None#',
        ['SolubleAdhesive']: data['enums/AdhesiveType/SolubleAdhesive'] || '#enums/AdhesiveType/SolubleAdhesive#',
        ['NonSolubleAdhesive']: data['enums/AdhesiveType/NonSolubleAdhesive'] || '#enums/AdhesiveType/NonSolubleAdhesive#',
      },
      ['AdhesiveApplication']: {
        ['Areal']: data['enums/AdhesiveApplication/Areal'] || '#enums/AdhesiveApplication/Areal#',
        ['Selective']: data['enums/AdhesiveApplication/Selective'] || '#enums/AdhesiveApplication/Selective#',
      },
      ['ContentType']: {
        ['Solid']: data['enums/ContentType/Solid'] || '#enums/ContentType/Solid#',
        ['Pasty']: data['enums/ContentType/Pasty'] || '#enums/ContentType/Pasty#',
        ['Liquid']: data['enums/ContentType/Liquid'] || '#enums/ContentType/Liquid#',
        ['Other']: data['enums/ContentType/Other'] || '#enums/ContentType/Other#',
      },
      ['MaterialFamily']: {
        ['Plastics']: data['enums/MaterialFamily/Plastics'] || '#enums/MaterialFamily/Plastics#',
        ['Fibers']: data['enums/MaterialFamily/Fibers'] || '#enums/MaterialFamily/Fibers#',
        ['Metals']: data['enums/MaterialFamily/Metals'] || '#enums/MaterialFamily/Metals#',
        ['Glass']: data['enums/MaterialFamily/Glass'] || '#enums/MaterialFamily/Glass#',
        ['Composites']: data['enums/MaterialFamily/Composites'] || '#enums/MaterialFamily/Composites#',
        ['OtherMaterials']: data['enums/MaterialFamily/OtherMaterials'] || '#enums/MaterialFamily/OtherMaterials#',
      },
      ['Material']: {
        ['PET']: data['enums/Material/PET'] || '#enums/Material/PET#',
        ['PETWithBarrierAdditive']: data['enums/Material/PETWithBarrierAdditive'] || '#enums/Material/PETWithBarrierAdditive#',
        ['PETG']: data['enums/Material/PETG'] || '#enums/Material/PETG#',
        ['PEHD']: data['enums/Material/PEHD'] || '#enums/Material/PEHD#',
        ['PELD']: data['enums/Material/PELD'] || '#enums/Material/PELD#',
        ['PEX']: data['enums/Material/PEX'] || '#enums/Material/PEX#',
        ['PP']: data['enums/Material/PP'] || '#enums/Material/PP#',
        ['PS']: data['enums/Material/PS'] || '#enums/Material/PS#',
        ['PSE']: data['enums/Material/PSE'] || '#enums/Material/PSE#',
        ['PSO']: data['enums/Material/PSO'] || '#enums/Material/PSO#',
        ['PA']: data['enums/Material/PA'] || '#enums/Material/PA#',
        ['PAWithException']: data['enums/Material/PAWithException'] || '#enums/Material/PAWithException#',
        ['POM']: data['enums/Material/POM'] || '#enums/Material/POM#',
        ['PC']: data['enums/Material/PC'] || '#enums/Material/PC#',
        ['PVC']: data['enums/Material/PVC'] || '#enums/Material/PVC#',
        ['PVDC']: data['enums/Material/PVDC'] || '#enums/Material/PVDC#',
        ['PBS']: data['enums/Material/PBS'] || '#enums/Material/PBS#',
        ['PLA']: data['enums/Material/PLA'] || '#enums/Material/PLA#',
        ['ABS']: data['enums/Material/ABS'] || '#enums/Material/ABS#',
        ['PMMA']: data['enums/Material/PMMA'] || '#enums/Material/PMMA#',
        ['ElastomerRubber']: data['enums/Material/ElastomerRubber'] || '#enums/Material/ElastomerRubber#',
        ['ElastomerThermoplastic']: data['enums/Material/ElastomerThermoplastic'] || '#enums/Material/ElastomerThermoplastic#',
        ['EVOH']: data['enums/Material/EVOH'] || '#enums/Material/EVOH#',
        ['Silicone']: data['enums/Material/Silicone'] || '#enums/Material/Silicone#',
        ['EVA']: data['enums/Material/EVA'] || '#enums/Material/EVA#',
        ['WaxParaffine']: data['enums/Material/WaxParaffine'] || '#enums/Material/WaxParaffine#',
        ['Cardboard']: data['enums/Material/Cardboard'] || '#enums/Material/Cardboard#',
        ['CardboardWetResistant']: data['enums/Material/CardboardWetResistant'] || '#enums/Material/CardboardWetResistant#',
        ['MouldedPaper']: data['enums/Material/MouldedPaper'] || '#enums/Material/MouldedPaper#',
        ['MouldedPaperWetResistant']: data['enums/Material/MouldedPaperWetResistant'] || '#enums/Material/MouldedPaperWetResistant#',
        ['Paper']: data['enums/Material/Paper'] || '#enums/Material/Paper#',
        ['PaperWetResistant']: data['enums/Material/PaperWetResistant'] || '#enums/Material/PaperWetResistant#',
        ['Paperboard']: data['enums/Material/Paperboard'] || '#enums/Material/Paperboard#',
        ['PaperboardWetResistant']: data['enums/Material/PaperboardWetResistant'] || '#enums/Material/PaperboardWetResistant#',
        ['Aluminium']: data['enums/Material/Aluminium'] || '#enums/Material/Aluminium#',
        ['FE']: data['enums/Material/FE'] || '#enums/Material/FE#',
        ['AlOx']: data['enums/Material/AlOx'] || '#enums/Material/AlOx#',
        ['SodaLimeGlass']: data['enums/Material/SodaLimeGlass'] || '#enums/Material/SodaLimeGlass#',
        ['SiOx']: data['enums/Material/SiOx'] || '#enums/Material/SiOx#',
        ['OtherGlass']: data['enums/Material/OtherGlass'] || '#enums/Material/OtherGlass#',
        ['Ceramic']: data['enums/Material/Ceramic'] || '#enums/Material/Ceramic#',
        ['Natural']: data['enums/Material/Natural'] || '#enums/Material/Natural#',
        ['Superabsorber']: data['enums/Material/Superabsorber'] || '#enums/Material/Superabsorber#',
        ['MultilayerPlastic']: data['enums/Material/MultilayerPlastic'] || '#enums/Material/MultilayerPlastic#',
        ['FiberWithOthers']: data['enums/Material/FiberWithOthers'] || '#enums/Material/FiberWithOthers#',
        ['BeverageCarton']: data['enums/Material/BeverageCarton'] || '#enums/Material/BeverageCarton#',
        ['OtherComposite']: data['enums/Material/OtherComposite'] || '#enums/Material/OtherComposite#',
      },
      ['Component']: {
        ['Bag']: data['enums/Component/Bag'] || '#enums/Component/Bag#',
        ['Blister']: data['enums/Component/Blister'] || '#enums/Component/Blister#',
        ['Bottle']: data['enums/Component/Bottle'] || '#enums/Component/Bottle#',
        ['Box']: data['enums/Component/Box'] || '#enums/Component/Box#',
        ['Can']: data['enums/Component/Can'] || '#enums/Component/Can#',
        ['CapLid']: data['enums/Component/CapLid'] || '#enums/Component/CapLid#',
        ['CapOther']: data['enums/Component/CapOther'] || '#enums/Component/CapOther#',
        ['CapSpray']: data['enums/Component/CapSpray'] || '#enums/Component/CapSpray#',
        ['CapTwist']: data['enums/Component/CapTwist'] || '#enums/Component/CapTwist#',
        ['Clamshell']: data['enums/Component/Clamshell'] || '#enums/Component/Clamshell#',
        ['Cup']: data['enums/Component/Cup'] || '#enums/Component/Cup#',
        ['Dosifier']: data['enums/Component/Dosifier'] || '#enums/Component/Dosifier#',
        ['Doypack']: data['enums/Component/Doypack'] || '#enums/Component/Doypack#',
        ['Handle']: data['enums/Component/Handle'] || '#enums/Component/Handle#',
        ['Hanger']: data['enums/Component/Hanger'] || '#enums/Component/Hanger#',
        ['Insert']: data['enums/Component/Insert'] || '#enums/Component/Insert#',
        ['Jar']: data['enums/Component/Jar'] || '#enums/Component/Jar#',
        ['LabelAdhesive']: data['enums/Component/LabelAdhesive'] || '#enums/Component/LabelAdhesive#',
        ['LabelInMold']: data['enums/Component/LabelInMold'] || '#enums/Component/LabelInMold#',
        ['LabelLooseSleeve']: data['enums/Component/LabelLooseSleeve'] || '#enums/Component/LabelLooseSleeve#',
        ['LabelOther']: data['enums/Component/LabelOther'] || '#enums/Component/LabelOther#',
        ['LabelShrinkwrap']: data['enums/Component/LabelShrinkwrap'] || '#enums/Component/LabelShrinkwrap#',
        ['Pouch']: data['enums/Component/Pouch'] || '#enums/Component/Pouch#',
        ['SecuritySeal']: data['enums/Component/SecuritySeal'] || '#enums/Component/SecuritySeal#',
        ['SwingTop']: data['enums/Component/SwingTop'] || '#enums/Component/SwingTop#',
        ['Tie']: data['enums/Component/Tie'] || '#enums/Component/Tie#',
        ['Tray']: data['enums/Component/Tray'] || '#enums/Component/Tray#',
        ['Tube']: data['enums/Component/Tube'] || '#enums/Component/Tube#',
        ['Valve']: data['enums/Component/Valve'] || '#enums/Component/Valve#',
        ['Wrapper']: data['enums/Component/Wrapper'] || '#enums/Component/Wrapper#',
        ['BeverageBottle']: data['enums/Component/BeverageBottle'] || '#enums/Component/BeverageBottle#',
        ['Net']: data['enums/Component/Net'] || '#enums/Component/Net#',
        ['groups']: {
          ['Main']: data['enums/Component/groups/Main'] || '#enums/Component/groups/Main#',
          ['Labels']: data['enums/Component/groups/Labels'] || '#enums/Component/groups/Labels#',
          ['Caps']: data['enums/Component/groups/Caps'] || '#enums/Component/groups/Caps#',
          ['Others']: data['enums/Component/groups/Others'] || '#enums/Component/groups/Others#',
        },
      },
      ['Color']: {
        ['Any']: data['enums/Color/Any'] || '#enums/Color/Any#',
        ['AnyColorButBlack']: data['enums/Color/AnyColorButBlack'] || '#enums/Color/AnyColorButBlack#',
        ['Black']: data['enums/Color/Black'] || '#enums/Color/Black#',
        ['BlackNotSootBased']: data['enums/Color/BlackNotSootBased'] || '#enums/Color/BlackNotSootBased#',
        ['BlueTransparent']: data['enums/Color/BlueTransparent'] || '#enums/Color/BlueTransparent#',
        ['BrownTransparent']: data['enums/Color/BrownTransparent'] || '#enums/Color/BrownTransparent#',
        ['ClearTransparent']: data['enums/Color/ClearTransparent'] || '#enums/Color/ClearTransparent#',
        ['ClearColorful']: data['enums/Color/ClearColorful'] || '#enums/Color/ClearColorful#',
        ['ClearWithDirectPrinting']: data['enums/Color/ClearWithDirectPrinting'] || '#enums/Color/ClearWithDirectPrinting#',
        ['GreenTransparent']: data['enums/Color/GreenTransparent'] || '#enums/Color/GreenTransparent#',
        ['HolograficPrinting']: data['enums/Color/HolograficPrinting'] || '#enums/Color/HolograficPrinting#',
        ['Kraft']: data['enums/Color/Kraft'] || '#enums/Color/Kraft#',
        ['MetallizedPrinting']: data['enums/Color/MetallizedPrinting'] || '#enums/Color/MetallizedPrinting#',
        ['NaturalClear']: data['enums/Color/NaturalClear'] || '#enums/Color/NaturalClear#',
        ['Opaque']: data['enums/Color/Opaque'] || '#enums/Color/Opaque#',
        ['OtherColor']: data['enums/Color/OtherColor'] || '#enums/Color/OtherColor#',
        ['PrintedBlack']: data['enums/Color/PrintedBlack'] || '#enums/Color/PrintedBlack#',
        ['PrintedBlackNotSootBased']: data['enums/Color/PrintedBlackNotSootBased'] || '#enums/Color/PrintedBlackNotSootBased#',
        ['PrintedDarkColors']: data['enums/Color/PrintedDarkColors'] || '#enums/Color/PrintedDarkColors#',
        ['PrintedLightColors']: data['enums/Color/PrintedLightColors'] || '#enums/Color/PrintedLightColors#',
        ['White']: data['enums/Color/White'] || '#enums/Color/White#',
        ['BlackNIRDetectable']: data['enums/Color/BlackNIRDetectable'] || '#enums/Color/BlackNIRDetectable#',
      },
      ['DensityModification']: {
        ['None']: data['enums/DensityModification/None'] || '#enums/DensityModification/None#',
        ['Foamt']: data['enums/DensityModification/Foamt'] || '#enums/DensityModification/Foamt#',
        ['Filled']: data['enums/DensityModification/Filled'] || '#enums/DensityModification/Filled#',
      },
    },
    ['DE2020']: {
      ['infrastructure']: {
        ['sufficient']: (parameters: { fraction: string }) => replace(data['DE2020/infrastructure/sufficient'] || '#DE2020/infrastructure/sufficient#', parameters),
        ['limited']: (parameters: { fraction: string }) => replace(data['DE2020/infrastructure/limited'] || '#DE2020/infrastructure/limited#', parameters),
        ['marginal']: (parameters: { fraction: string }) => replace(data['DE2020/infrastructure/marginal'] || '#DE2020/infrastructure/marginal#', parameters),
        ['missing']: data['DE2020/infrastructure/missing'] || '#DE2020/infrastructure/missing#',
        ['fraction']: {
          ['stablePE']: data['DE2020/infrastructure/fraction/stablePE'] || '#DE2020/infrastructure/fraction/stablePE#',
          ['stablePP']: data['DE2020/infrastructure/fraction/stablePP'] || '#DE2020/infrastructure/fraction/stablePP#',
          ['stablePS']: data['DE2020/infrastructure/fraction/stablePS'] || '#DE2020/infrastructure/fraction/stablePS#',
          ['stablePEOrPE']: data['DE2020/infrastructure/fraction/stablePEOrPE'] || '#DE2020/infrastructure/fraction/stablePEOrPE#',
          ['petBottleGrade']: data['DE2020/infrastructure/fraction/petBottleGrade'] || '#DE2020/infrastructure/fraction/petBottleGrade#',
          ['petMonolayer']: data['DE2020/infrastructure/fraction/petMonolayer'] || '#DE2020/infrastructure/fraction/petMonolayer#',
          ['flexiblePEDINA4']: data['DE2020/infrastructure/fraction/flexiblePEDINA4'] || '#DE2020/infrastructure/fraction/flexiblePEDINA4#',
          ['flexiblePPDINA4']: data['DE2020/infrastructure/fraction/flexiblePPDINA4'] || '#DE2020/infrastructure/fraction/flexiblePPDINA4#',
          ['flexiblePENoDINA4']: data['DE2020/infrastructure/fraction/flexiblePENoDINA4'] || '#DE2020/infrastructure/fraction/flexiblePENoDINA4#',
          ['flexiblePPNoDINA4']: data['DE2020/infrastructure/fraction/flexiblePPNoDINA4'] || '#DE2020/infrastructure/fraction/flexiblePPNoDINA4#',
          ['eps']: data['DE2020/infrastructure/fraction/eps'] || '#DE2020/infrastructure/fraction/eps#',
          ['beverageCarton']: data['DE2020/infrastructure/fraction/beverageCarton'] || '#DE2020/infrastructure/fraction/beverageCarton#',
          ['fiberComposite']: data['DE2020/infrastructure/fraction/fiberComposite'] || '#DE2020/infrastructure/fraction/fiberComposite#',
          ['fiber']: data['DE2020/infrastructure/fraction/fiber'] || '#DE2020/infrastructure/fraction/fiber#',
          ['steel']: data['DE2020/infrastructure/fraction/steel'] || '#DE2020/infrastructure/fraction/steel#',
          ['aluminum']: data['DE2020/infrastructure/fraction/aluminum'] || '#DE2020/infrastructure/fraction/aluminum#',
          ['glass']: data['DE2020/infrastructure/fraction/glass'] || '#DE2020/infrastructure/fraction/glass#',
        },
      },
      ['sorting']: {
        ['verificationRequiredMessage']: data['DE2020/sorting/verificationRequiredMessage'] || '#DE2020/sorting/verificationRequiredMessage#',
        ['fibers']: {
          ['metalization']: (parameters: { part: string }) => replace(data['DE2020/sorting/fibers/metalization'] || '#DE2020/sorting/fibers/metalization#', parameters),
          ['lacquered']: (parameters: { part: string }) => replace(data['DE2020/sorting/fibers/lacquered'] || '#DE2020/sorting/fibers/lacquered#', parameters),
          ['sootBasedColor']: (parameters: { part: string }) => replace(data['DE2020/sorting/fibers/sootBasedColor'] || '#DE2020/sorting/fibers/sootBasedColor#', parameters),
          ['coatedWithPlastic']: (parameters: { part: string }) => replace(data['DE2020/sorting/fibers/coatedWithPlastic'] || '#DE2020/sorting/fibers/coatedWithPlastic#', parameters),
        },
        ['glass']: {
          ['opaque']: (parameters: { part: string }) => replace(data['DE2020/sorting/glass/opaque'] || '#DE2020/sorting/glass/opaque#', parameters),
        },
        ['plastics']: {
          ['moreThan50PercentHiddenBySingleLabel']: (parameters: { part: string; label: string }) => replace(data['DE2020/sorting/plastics/moreThan50PercentHiddenBySingleLabel'] || '#DE2020/sorting/plastics/moreThan50PercentHiddenBySingleLabel#', parameters),
          ['moreThan50PercentHiddenByMultipleLabels']: (parameters: { part: string; labels: string }) => replace(data['DE2020/sorting/plastics/moreThan50PercentHiddenByMultipleLabels'] || '#DE2020/sorting/plastics/moreThan50PercentHiddenByMultipleLabels#', parameters),
          ['multilayerConstruction']: (parameters: { part: string }) => replace(data['DE2020/sorting/plastics/multilayerConstruction'] || '#DE2020/sorting/plastics/multilayerConstruction#', parameters),
          ['sootBasedColor']: (parameters: { part: string }) => replace(data['DE2020/sorting/plastics/sootBasedColor'] || '#DE2020/sorting/plastics/sootBasedColor#', parameters),
          ['metalization']: (parameters: { part: string }) => replace(data['DE2020/sorting/plastics/metalization'] || '#DE2020/sorting/plastics/metalization#', parameters),
          ['hasDifferentMaterialOnOpposingSide']: (parameters: { part: string }) => replace(data['DE2020/sorting/plastics/hasDifferentMaterialOnOpposingSide'] || '#DE2020/sorting/plastics/hasDifferentMaterialOnOpposingSide#', parameters),
        },
      },
      ['refining']: {
        ['verificationRequiredMessage']: data['DE2020/refining/verificationRequiredMessage'] || '#DE2020/refining/verificationRequiredMessage#',
        ['noRecyclableMaterial']: data['DE2020/refining/noRecyclableMaterial'] || '#DE2020/refining/noRecyclableMaterial#',
        ['plastics']: {
          ['nonPOPlasticWithDensityLowerThan1Present']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/nonPOPlasticWithDensityLowerThan1Present'] || '#DE2020/refining/plastics/nonPOPlasticWithDensityLowerThan1Present#', parameters),
          ['nonPSPlasticWithDensityBetween1_0And1_08Present']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/nonPSPlasticWithDensityBetween1_0And1_08Present'] || '#DE2020/refining/plastics/nonPSPlasticWithDensityBetween1_0And1_08Present#', parameters),
          ['peXPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/peXPresent'] || '#DE2020/refining/plastics/peXPresent#', parameters),
          ['petGPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/petGPresent'] || '#DE2020/refining/plastics/petGPresent#', parameters),
          ['pvcPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/pvcPresent'] || '#DE2020/refining/plastics/pvcPresent#', parameters),
          ['pomPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/pomPresent'] || '#DE2020/refining/plastics/pomPresent#', parameters),
          ['elastomerWithDensityHigher1Present']: (parameters: { part: string; density: string; fractions: string }) => replace(data['DE2020/refining/plastics/elastomerWithDensityHigher1Present'] || '#DE2020/refining/plastics/elastomerWithDensityHigher1Present#', parameters),
          ['psLabelPresent']: (parameters: { label: string; fractions: string }) => replace(data['DE2020/refining/plastics/psLabelPresent'] || '#DE2020/refining/plastics/psLabelPresent#', parameters),
          ['barrierAdditivePresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/barrierAdditivePresent'] || '#DE2020/refining/plastics/barrierAdditivePresent#', parameters),
          ['paBarrierPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/paBarrierPresent'] || '#DE2020/refining/plastics/paBarrierPresent#', parameters),
          ['pvcBarrierPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/pvcBarrierPresent'] || '#DE2020/refining/plastics/pvcBarrierPresent#', parameters),
          ['evohBarrierPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/evohBarrierPresent'] || '#DE2020/refining/plastics/evohBarrierPresent#', parameters),
          ['nonEVOHBarrierPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/nonEVOHBarrierPresent'] || '#DE2020/refining/plastics/nonEVOHBarrierPresent#', parameters),
          ['nonFerrousMetalsPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/nonFerrousMetalsPresent'] || '#DE2020/refining/plastics/nonFerrousMetalsPresent#', parameters),
          ['hasDirectPrinting']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/hasDirectPrinting'] || '#DE2020/refining/plastics/hasDirectPrinting#', parameters),
          ['siliconePresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/siliconePresent'] || '#DE2020/refining/plastics/siliconePresent#', parameters),
          ['nonSolubleLabelWithNonSolubleAdhesivePresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/nonSolubleLabelWithNonSolubleAdhesivePresent'] || '#DE2020/refining/plastics/nonSolubleLabelWithNonSolubleAdhesivePresent#', parameters),
          ['labelWithNonSolubleAdhesivePresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2020/refining/plastics/labelWithNonSolubleAdhesivePresent'] || '#DE2020/refining/plastics/labelWithNonSolubleAdhesivePresent#', parameters),
          ['adhesiveApplicationPresent']: (parameters: { part: string }) => replace(data['DE2020/refining/plastics/adhesiveApplicationPresent'] || '#DE2020/refining/plastics/adhesiveApplicationPresent#', parameters),
        },
        ['glass']: {
          ['onlyNonFerrousMetalsPresent']: (parameters: { closure: string }) => replace(data['DE2020/refining/glass/onlyNonFerrousMetalsPresent'] || '#DE2020/refining/glass/onlyNonFerrousMetalsPresent#', parameters),
        },
        ['fibers']: {
          ['adhesiveApplicationPresent']: (parameters: { part: string }) => replace(data['DE2020/refining/fibers/adhesiveApplicationPresent'] || '#DE2020/refining/fibers/adhesiveApplicationPresent#', parameters),
          ['nonSolublePartPresent']: (parameters: { part: string }) => replace(data['DE2020/refining/fibers/nonSolublePartPresent'] || '#DE2020/refining/fibers/nonSolublePartPresent#', parameters),
        },
      },
      ['rating']: {
        ['headerTitle']: (parameters: { name: string }) => replace(data['DE2020/rating/headerTitle'] || '#DE2020/rating/headerTitle#', parameters),
        ['headerRatingHtml']: data['DE2020/rating/headerRatingHtml'] || '#DE2020/rating/headerRatingHtml#',
        ['headerNoRatingHtml']: (parameters: { name: string }) => replace(data['DE2020/rating/headerNoRatingHtml'] || '#DE2020/rating/headerNoRatingHtml#', parameters),
        ['contactTitle']: data['DE2020/rating/contactTitle'] || '#DE2020/rating/contactTitle#',
        ['contactHtml']: (parameters: { name: string }) => replace(data['DE2020/rating/contactHtml'] || '#DE2020/rating/contactHtml#', parameters),
      },
      ['report']: {
        ['navTitle']: data['DE2020/report/navTitle'] || '#DE2020/report/navTitle#',
        ['headerTitle']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/headerTitle'] || '#DE2020/report/headerTitle#', parameters),
        ['headerTitleWithGtin']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/headerTitleWithGtin'] || '#DE2020/report/headerTitleWithGtin#', parameters),
        ['headerText']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/headerText'] || '#DE2020/report/headerText#', parameters),
        ['sortingTitle']: data['DE2020/report/sortingTitle'] || '#DE2020/report/sortingTitle#',
        ['refiningTitle']: data['DE2020/report/refiningTitle'] || '#DE2020/report/refiningTitle#',
        ['sortingVerificationText']: data['DE2020/report/sortingVerificationText'] || '#DE2020/report/sortingVerificationText#',
        ['refiningVerificationText']: data['DE2020/report/refiningVerificationText'] || '#DE2020/report/refiningVerificationText#',
        ['sortingAndRefiningVerificationText']: data['DE2020/report/sortingAndRefiningVerificationText'] || '#DE2020/report/sortingAndRefiningVerificationText#',
        ['recycableMaterialText']: data['DE2020/report/recycableMaterialText'] || '#DE2020/report/recycableMaterialText#',
        ['missingInputTitle']: data['DE2020/report/missingInputTitle'] || '#DE2020/report/missingInputTitle#',
        ['background']: {
          ['title']: data['DE2020/report/background/title'] || '#DE2020/report/background/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/background/text'] || '#DE2020/report/background/text#', parameters),
        },
        ['disclaimer']: {
          ['title']: data['DE2020/report/disclaimer/title'] || '#DE2020/report/disclaimer/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/disclaimer/text'] || '#DE2020/report/disclaimer/text#', parameters),
        },
        ['method']: {
          ['title']: data['DE2020/report/method/title'] || '#DE2020/report/method/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/method/text'] || '#DE2020/report/method/text#', parameters),
        },
        ['methodDisposal']: {
          ['title']: data['DE2020/report/methodDisposal/title'] || '#DE2020/report/methodDisposal/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/methodDisposal/text'] || '#DE2020/report/methodDisposal/text#', parameters),
        },
        ['methodSorting']: {
          ['title']: data['DE2020/report/methodSorting/title'] || '#DE2020/report/methodSorting/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/methodSorting/text'] || '#DE2020/report/methodSorting/text#', parameters),
        },
        ['methodRefining']: {
          ['title']: data['DE2020/report/methodRefining/title'] || '#DE2020/report/methodRefining/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/methodRefining/text'] || '#DE2020/report/methodRefining/text#', parameters),
        },
        ['methodRecycability']: {
          ['title']: data['DE2020/report/methodRecycability/title'] || '#DE2020/report/methodRecycability/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/methodRecycability/text'] || '#DE2020/report/methodRecycability/text#', parameters),
        },
        ['input']: {
          ['title']: data['DE2020/report/input/title'] || '#DE2020/report/input/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/input/text'] || '#DE2020/report/input/text#', parameters),
        },
        ['inputParts']: {
          ['title']: data['DE2020/report/inputParts/title'] || '#DE2020/report/inputParts/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/inputParts/text'] || '#DE2020/report/inputParts/text#', parameters),
          ['tablePartHeader']: data['DE2020/report/inputParts/tablePartHeader'] || '#DE2020/report/inputParts/tablePartHeader#',
          ['tableMaterialHeader']: data['DE2020/report/inputParts/tableMaterialHeader'] || '#DE2020/report/inputParts/tableMaterialHeader#',
          ['tableMaterialDensityLabel']: (parameters: { density: string }) => replace(data['DE2020/report/inputParts/tableMaterialDensityLabel'] || '#DE2020/report/inputParts/tableMaterialDensityLabel#', parameters),
          ['tableColorHeader']: data['DE2020/report/inputParts/tableColorHeader'] || '#DE2020/report/inputParts/tableColorHeader#',
          ['tableWeightHeader']: data['DE2020/report/inputParts/tableWeightHeader'] || '#DE2020/report/inputParts/tableWeightHeader#',
          ['tableDimensionHeader']: data['DE2020/report/inputParts/tableDimensionHeader'] || '#DE2020/report/inputParts/tableDimensionHeader#',
        },
        ['inputAssumptions']: {
          ['title']: data['DE2020/report/inputAssumptions/title'] || '#DE2020/report/inputAssumptions/title#',
        },
        ['output']: {
          ['title']: data['DE2020/report/output/title'] || '#DE2020/report/output/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/output/text'] || '#DE2020/report/output/text#', parameters),
        },
        ['outputScenarios']: {
          ['title']: data['DE2020/report/outputScenarios/title'] || '#DE2020/report/outputScenarios/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/outputScenarios/text'] || '#DE2020/report/outputScenarios/text#', parameters),
        },
        ['recycableMaterialTable']: {
          ['partHeader']: data['DE2020/report/recycableMaterialTable/partHeader'] || '#DE2020/report/recycableMaterialTable/partHeader#',
          ['weightFractionHeader']: data['DE2020/report/recycableMaterialTable/weightFractionHeader'] || '#DE2020/report/recycableMaterialTable/weightFractionHeader#',
          ['recycableMaterialHeader']: data['DE2020/report/recycableMaterialTable/recycableMaterialHeader'] || '#DE2020/report/recycableMaterialTable/recycableMaterialHeader#',
        },
        ['outputObservations']: {
          ['title']: data['DE2020/report/outputObservations/title'] || '#DE2020/report/outputObservations/title#',
        },
        ['proposals']: {
          ['title']: data['DE2020/report/proposals/title'] || '#DE2020/report/proposals/title#',
          ['text']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['DE2020/report/proposals/text'] || '#DE2020/report/proposals/text#', parameters),
        },
        ['ratingLegend']: {
          ['range']: (parameters: { from: string; to: string }) => replace(data['DE2020/report/ratingLegend/range'] || '#DE2020/report/ratingLegend/range#', parameters),
          ['APlusPlusPlus']: data['DE2020/report/ratingLegend/APlusPlusPlus'] || '#DE2020/report/ratingLegend/APlusPlusPlus#',
          ['APlusPlus']: data['DE2020/report/ratingLegend/APlusPlus'] || '#DE2020/report/ratingLegend/APlusPlus#',
          ['APlus']: data['DE2020/report/ratingLegend/APlus'] || '#DE2020/report/ratingLegend/APlus#',
          ['A']: data['DE2020/report/ratingLegend/A'] || '#DE2020/report/ratingLegend/A#',
          ['B']: data['DE2020/report/ratingLegend/B'] || '#DE2020/report/ratingLegend/B#',
          ['C']: data['DE2020/report/ratingLegend/C'] || '#DE2020/report/ratingLegend/C#',
        },
      },
      ['certify']: {
        ['title']: (parameters: { product: string }) => replace(data['DE2020/certify/title'] || '#DE2020/certify/title#', parameters),
        ['intro']: (parameters: { company: string }) => replace(data['DE2020/certify/intro'] || '#DE2020/certify/intro#', parameters),
        ['method']: (parameters: { methodDate: string; date: string }) => replace(data['DE2020/certify/method'] || '#DE2020/certify/method#', parameters),
        ['rating']: data['DE2020/certify/rating'] || '#DE2020/certify/rating#',
        ['szenario']: data['DE2020/certify/szenario'] || '#DE2020/certify/szenario#',
        ['validity']: (parameters: { referenceNr: string }) => replace(data['DE2020/certify/validity'] || '#DE2020/certify/validity#', parameters),
        ['signature']: (parameters: { date: string }) => replace(data['DE2020/certify/signature'] || '#DE2020/certify/signature#', parameters),
        ['phone']: data['DE2020/certify/phone'] || '#DE2020/certify/phone#',
        ['parts']: {
          ['header']: (parameters: { product: string }) => replace(data['DE2020/certify/parts/header'] || '#DE2020/certify/parts/header#', parameters),
          ['name']: data['DE2020/certify/parts/name'] || '#DE2020/certify/parts/name#',
          ['material']: data['DE2020/certify/parts/material'] || '#DE2020/certify/parts/material#',
          ['color']: data['DE2020/certify/parts/color'] || '#DE2020/certify/parts/color#',
          ['weight']: data['DE2020/certify/parts/weight'] || '#DE2020/certify/parts/weight#',
          ['dimension']: data['DE2020/certify/parts/dimension'] || '#DE2020/certify/parts/dimension#',
          ['footer']: (parameters: { id: string }) => replace(data['DE2020/certify/parts/footer'] || '#DE2020/certify/parts/footer#', parameters),
        },
        ['classifications']: {
          ['class1']: {
            ['name']: data['DE2020/certify/classifications/class1/name'] || '#DE2020/certify/classifications/class1/name#',
            ['range']: data['DE2020/certify/classifications/class1/range'] || '#DE2020/certify/classifications/class1/range#',
            ['description']: data['DE2020/certify/classifications/class1/description'] || '#DE2020/certify/classifications/class1/description#',
          },
          ['class2']: {
            ['name']: data['DE2020/certify/classifications/class2/name'] || '#DE2020/certify/classifications/class2/name#',
            ['range']: data['DE2020/certify/classifications/class2/range'] || '#DE2020/certify/classifications/class2/range#',
            ['description']: data['DE2020/certify/classifications/class2/description'] || '#DE2020/certify/classifications/class2/description#',
          },
          ['class3']: {
            ['name']: data['DE2020/certify/classifications/class3/name'] || '#DE2020/certify/classifications/class3/name#',
            ['range']: data['DE2020/certify/classifications/class3/range'] || '#DE2020/certify/classifications/class3/range#',
            ['description']: data['DE2020/certify/classifications/class3/description'] || '#DE2020/certify/classifications/class3/description#',
          },
          ['class4']: {
            ['name']: data['DE2020/certify/classifications/class4/name'] || '#DE2020/certify/classifications/class4/name#',
            ['range']: data['DE2020/certify/classifications/class4/range'] || '#DE2020/certify/classifications/class4/range#',
            ['description']: data['DE2020/certify/classifications/class4/description'] || '#DE2020/certify/classifications/class4/description#',
          },
          ['class5']: {
            ['name']: data['DE2020/certify/classifications/class5/name'] || '#DE2020/certify/classifications/class5/name#',
            ['range']: data['DE2020/certify/classifications/class5/range'] || '#DE2020/certify/classifications/class5/range#',
            ['description']: data['DE2020/certify/classifications/class5/description'] || '#DE2020/certify/classifications/class5/description#',
          },
        },
      },
    },
    ['DE2021']: {
      ['infrastructure']: {
        ['fraction']: {
          ['beverageCarton']: data['DE2021/infrastructure/fraction/beverageCarton'] || '#DE2021/infrastructure/fraction/beverageCarton#',
          ['fiber']: data['DE2021/infrastructure/fraction/fiber'] || '#DE2021/infrastructure/fraction/fiber#',
        },
      },
      ['detrimentalResidues']: {
        ['sealants']: (parameters: { fraction: string }) => replace(data['DE2021/detrimentalResidues/sealants'] || '#DE2021/detrimentalResidues/sealants#', parameters),
      },
      ['refining']: {
        ['plastics']: {
          ['nonSolubleCellulosicLabelPresent']: (parameters: { part: string; fractions: string }) => replace(data['DE2021/refining/plastics/nonSolubleCellulosicLabelPresent'] || '#DE2021/refining/plastics/nonSolubleCellulosicLabelPresent#', parameters),
        },
      },
    },
    ['AT2020']: {
      ['infrastructure']: {
        ['fraction']: {
          ['glass']: data['AT2020/infrastructure/fraction/glass'] || '#AT2020/infrastructure/fraction/glass#',
          ['fiber']: data['AT2020/infrastructure/fraction/fiber'] || '#AT2020/infrastructure/fraction/fiber#',
          ['steel']: data['AT2020/infrastructure/fraction/steel'] || '#AT2020/infrastructure/fraction/steel#',
          ['stablePESmallerThan5L']: data['AT2020/infrastructure/fraction/stablePESmallerThan5L'] || '#AT2020/infrastructure/fraction/stablePESmallerThan5L#',
          ['stablePEGreaterOrEqualTo5L']: data['AT2020/infrastructure/fraction/stablePEGreaterOrEqualTo5L'] || '#AT2020/infrastructure/fraction/stablePEGreaterOrEqualTo5L#',
          ['stablePPSmallerThan10L']: data['AT2020/infrastructure/fraction/stablePPSmallerThan10L'] || '#AT2020/infrastructure/fraction/stablePPSmallerThan10L#',
          ['stablePPGreaterOrEqualTo10L']: data['AT2020/infrastructure/fraction/stablePPGreaterOrEqualTo10L'] || '#AT2020/infrastructure/fraction/stablePPGreaterOrEqualTo10L#',
          ['stablePS']: data['AT2020/infrastructure/fraction/stablePS'] || '#AT2020/infrastructure/fraction/stablePS#',
          ['beverageBottlePET']: data['AT2020/infrastructure/fraction/beverageBottlePET'] || '#AT2020/infrastructure/fraction/beverageBottlePET#',
          ['nonBeverageBottlePET']: data['AT2020/infrastructure/fraction/nonBeverageBottlePET'] || '#AT2020/infrastructure/fraction/nonBeverageBottlePET#',
          ['petMonolayer']: data['AT2020/infrastructure/fraction/petMonolayer'] || '#AT2020/infrastructure/fraction/petMonolayer#',
          ['flexiblePE']: data['AT2020/infrastructure/fraction/flexiblePE'] || '#AT2020/infrastructure/fraction/flexiblePE#',
          ['eps']: data['AT2020/infrastructure/fraction/eps'] || '#AT2020/infrastructure/fraction/eps#',
          ['beverageCarton']: data['AT2020/infrastructure/fraction/beverageCarton'] || '#AT2020/infrastructure/fraction/beverageCarton#',
          ['aluminum']: data['AT2020/infrastructure/fraction/aluminum'] || '#AT2020/infrastructure/fraction/aluminum#',
        },
        ['remark']: {
          ['plastics']: data['AT2020/infrastructure/remark/plastics'] || '#AT2020/infrastructure/remark/plastics#',
        },
      },
      ['rating']: {
        ['headerRatingHtml']: data['AT2020/rating/headerRatingHtml'] || '#AT2020/rating/headerRatingHtml#',
      },
      ['report']: {
        ['headerText']: (parameters: { packagingName: string; packagingGtin: string; date: string }) => replace(data['AT2020/report/headerText'] || '#AT2020/report/headerText#', parameters),
      },
      ['certify']: {
        ['method']: (parameters: { date: string }) => replace(data['AT2020/certify/method'] || '#AT2020/certify/method#', parameters),
        ['validity']: (parameters: { referenceNr: string }) => replace(data['AT2020/certify/validity'] || '#AT2020/certify/validity#', parameters),
      },
    },
    ['DE2022']: {
      ['sorting']: {
        ['plastics']: {
          ['componentIsNet']: (parameters: { part: string }) => replace(data['DE2022/sorting/plastics/componentIsNet'] || '#DE2022/sorting/plastics/componentIsNet#', parameters),
        },
      },
      ['refining']: {
        ['glass']: {
          ['containsCeramic']: (parameters: { part: string }) => replace(data['DE2022/refining/glass/containsCeramic'] || '#DE2022/refining/glass/containsCeramic#', parameters),
          ['metalNet']: (parameters: { part: string }) => replace(data['DE2022/refining/glass/metalNet'] || '#DE2022/refining/glass/metalNet#', parameters),
        },
        ['fibers']: {
          ['polymericThermoplasticDispersionCoating']: (parameters: { part: string }) => replace(data['DE2022/refining/fibers/polymericThermoplasticDispersionCoating'] || '#DE2022/refining/fibers/polymericThermoplasticDispersionCoating#', parameters),
          ['liquidOrPastyContent']: data['DE2022/refining/fibers/liquidOrPastyContent'] || '#DE2022/refining/fibers/liquidOrPastyContent#',
        },
      },
    },
    ['DE2023']: {
      ['infrastructure']: {
        ['fraction']: {
          ['petMonolayer']: data['DE2023/infrastructure/fraction/petMonolayer'] || '#DE2023/infrastructure/fraction/petMonolayer#',
          ['flexiblePPNoDINA4']: data['DE2023/infrastructure/fraction/flexiblePPNoDINA4'] || '#DE2023/infrastructure/fraction/flexiblePPNoDINA4#',
        },
      },
      ['refining']: {
        ['plastics']: {
          ['ncBasedPrinting']: (parameters: { part: string }) => replace(data['DE2023/refining/plastics/ncBasedPrinting'] || '#DE2023/refining/plastics/ncBasedPrinting#', parameters),
        },
      },
    },
    ['FR2022']: {
      ['infrastructure']: {
        ['fraction']: {
          ['beverageCarton']: data['FR2022/infrastructure/fraction/beverageCarton'] || '#FR2022/infrastructure/fraction/beverageCarton#',
          ['fiberComposite']: data['FR2022/infrastructure/fraction/fiberComposite'] || '#FR2022/infrastructure/fraction/fiberComposite#',
          ['fiber']: data['FR2022/infrastructure/fraction/fiber'] || '#FR2022/infrastructure/fraction/fiber#',
          ['glass']: data['FR2022/infrastructure/fraction/glass'] || '#FR2022/infrastructure/fraction/glass#',
          ['aluminiumBig']: data['FR2022/infrastructure/fraction/aluminiumBig'] || '#FR2022/infrastructure/fraction/aluminiumBig#',
          ['aluminiumSmall']: data['FR2022/infrastructure/fraction/aluminiumSmall'] || '#FR2022/infrastructure/fraction/aluminiumSmall#',
          ['steel']: data['FR2022/infrastructure/fraction/steel'] || '#FR2022/infrastructure/fraction/steel#',
          ['complexPlasticFilm']: data['FR2022/infrastructure/fraction/complexPlasticFilm'] || '#FR2022/infrastructure/fraction/complexPlasticFilm#',
          ['flexiblePE']: data['FR2022/infrastructure/fraction/flexiblePE'] || '#FR2022/infrastructure/fraction/flexiblePE#',
          ['flexiblePP']: data['FR2022/infrastructure/fraction/flexiblePP'] || '#FR2022/infrastructure/fraction/flexiblePP#',
          ['PETBottlesColored']: data['FR2022/infrastructure/fraction/PETBottlesColored'] || '#FR2022/infrastructure/fraction/PETBottlesColored#',
          ['PETBottlesOpaque']: data['FR2022/infrastructure/fraction/PETBottlesOpaque'] || '#FR2022/infrastructure/fraction/PETBottlesOpaque#',
          ['PETBottlesTransparent']: data['FR2022/infrastructure/fraction/PETBottlesTransparent'] || '#FR2022/infrastructure/fraction/PETBottlesTransparent#',
          ['PETRigid']: data['FR2022/infrastructure/fraction/PETRigid'] || '#FR2022/infrastructure/fraction/PETRigid#',
          ['stablePE']: data['FR2022/infrastructure/fraction/stablePE'] || '#FR2022/infrastructure/fraction/stablePE#',
          ['stablePO']: data['FR2022/infrastructure/fraction/stablePO'] || '#FR2022/infrastructure/fraction/stablePO#',
          ['stablePP']: data['FR2022/infrastructure/fraction/stablePP'] || '#FR2022/infrastructure/fraction/stablePP#',
          ['stablePS']: data['FR2022/infrastructure/fraction/stablePS'] || '#FR2022/infrastructure/fraction/stablePS#',
        },
      },
      ['rating']: {
        ['headerRatingHtml']: data['FR2022/rating/headerRatingHtml'] || '#FR2022/rating/headerRatingHtml#',
      },
    },
    ['DE2024']: {
      ['remarks']: {
        ['beverageCartonMultiStageRefining']: data['DE2024/remarks/beverageCartonMultiStageRefining'] || '#DE2024/remarks/beverageCartonMultiStageRefining#',
      },
    },
    ['countries']: {
      ['germany']: data['countries/germany'] || '#countries/germany#',
      ['austria']: data['countries/austria'] || '#countries/austria#',
      ['france']: data['countries/france'] || '#countries/france#',
    },
  } as const;
}